module.exports = __webpack_public_path__ + "media/img/event/sponsor/ringgit-plus_logo2-9c23249bc9872cb1b11e1dbd75419047.png";